import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TrackingInterface } from 'src/interfaces/tracking'

type State = {
  loading: boolean
  entities: TrackingInterface[]
}

const initialState: State = {
  loading: false,
  entities: [],
}

const { actions, reducer } = createSlice({
  name: 'order_tracking',
  initialState,
  reducers: {
    updateEntities: (state, action: PayloadAction<TrackingInterface[]>) => {
      state.entities = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
